import { Route, Switch } from "react-router-dom";

import Authorized from "../Authorized";
import Users from "pages/Users";
import NewUser from "pages/NewUser";
import UpdateUser from "pages/UpdateUser";
import Products from "pages/Products";
import NewProduct from "pages/NewProduct";
import UpdateProduct from "pages/UpdateProduct";
import ProductCompatibilities from "pages/ProductCompatibilities";
import ProductCompatibility from "pages/ProductCompatibility";
import BaseProductMetadata from "pages/BaseProductMetadata";
import PDF from "pages/PDF";
import Quotes from "pages/Quotes";
import Groups from "pages/Groups";
import NewGroup from "pages/NewGroup";
import UpdateGroup from "pages/UpdateGroup";

const Main = (props) => {
  return (
    <div>
      <Switch>
        <Route
          exact
          path={`${props.match.path}/products`}
          render={() => (
            <Authorized
              render={() => {
                return <Products />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/products/new`}
          render={() => (
            <Authorized
              render={() => {
                return <NewProduct />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/products/:id`}
          render={() => (
            <Authorized
              render={() => {
                return <UpdateProduct />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/product-compatibilities`}
          render={() => (
            <Authorized
              render={() => {
                return <ProductCompatibilities />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/product-compatibilities/:_id`}
          render={() => (
            <Authorized
              render={() => {
                return <ProductCompatibility />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/base-product-metadata`}
          render={() => (
            <Authorized
              render={() => {
                return <BaseProductMetadata />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/groups`}
          render={() => (
            <Authorized
              render={() => {
                return <Groups />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/groups/new`}
          render={() => (
            <Authorized
              render={() => {
                return <NewGroup />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/groups/:id`}
          render={() => (
            <Authorized
              render={() => {
                return <UpdateGroup />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/users`}
          render={() => (
            <Authorized
              render={() => {
                return <Users />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/users/new`}
          render={() => (
            <Authorized
              render={() => {
                return <NewUser />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/users/:id`}
          render={() => (
            <Authorized
              render={() => {
                return <UpdateUser />;
              }}
            />
          )}
        />
        <Route
          exact
          path={`${props.match.path}/quotes`}
          render={() => (
            <Authorized
              render={() => {
                return <Quotes />;
              }}
            />
          )}
        />
      </Switch>
    </div>
  );
};

export default Main;
